import { jsx, css } from '@emotion/react';

import Dropdown from './oc-dropdown';
import FileBadge from './oc-file-badge';
import Link from './oc-link';
import getExtension from './utilities/file-extension';
import { connectLocation } from '../location/LocationConnectors';

const accordionStyles = css`
  .oc-dropdown-content {
    padding: 10px 35px 10px 17px;

    > a {
      display: block;
      line-height: 1.5em;
    }
  }

  .oc-file-badge {
    margin-left: 10px;

    @media (max-width: 1199px) {
      margin-bottom: 16px;
      display: block;
      margin-left: 0;
    }
  }
`;

const docType = (category, group) => {
  if (category) return category;

  let type;
  switch (group) {
    case 'leed':
      type = 'LEED guides';
      break;
    case 'environmental_product_declarations':
      type = 'EPD';
      break;
    case 'technical_bulletins':
      type = 'Technical Documents';
      break;
  }

  return type;
};

const DocumentTypeAccordion = connectLocation(({ t, groups, items }) => (
  <div css={accordionStyles}>
    {Object.entries(items).map(([key, documents], index) => (
      <Dropdown
        id={`dropdown-${key}`}
        key={key}
        label={`${t(`product.document_types.${key}`) || groups[key] || ''} (${documents.length})`}
        open={index === 0}
      >
        <div className="oc-dropdown-content">
          {documents.map(
            ({ value: vanityTitle, title, source, url, category, size_bytes, publication_id, id, key: docKey }) => (
              <Link
                target="_blank"
                href={source == 'dms2' ? `https://www.owenscorning.com/dms/${encodeURIComponent(publication_id)}` : url}
                data-track="file-download"
                data-track-file-type={getExtension(url)}
                data-track-file-name={title}
                data-track-element-location="accordion"
                data-track-doc-type={docType(category, key)}
                data-track-pubid={publication_id}
                key={publication_id || id || docKey}
              >
                {vanityTitle || title}
                <FileBadge extension={getExtension(url)} sizeBytes={size_bytes} />
              </Link>
            )
          )}
        </div>
      </Dropdown>
    ))}
  </div>
));

DocumentTypeAccordion.WrappedComponent.displayName = 'DocumentTypeAccordion';

export default DocumentTypeAccordion;
